import 'react-accessible-accordion/dist/fancy-example.css';
import './src/components/ui/modal-video/modal.css';

// Instant scroll behavior without delays
export const shouldUpdateScroll = ({
    routerProps: { location },
    getSavedScrollPosition,
}) => {
    if (typeof window === "undefined") return false;

    if (location.action === 'PUSH') {
        window.scrollTo(0, 0);
    } else {
        const savedPosition = getSavedScrollPosition(location);
        window.scrollTo(...(savedPosition || [0, 0]));
    }
    return false;
};
